import "../omega-theme.augmentation";
import { defineTheme, type ThemeDefinition } from "@omega/theme";

/**
 * Production light-пресет ТСД. \
 * Look продукта — здесь; механика темизации — в `@omega/theme`.
 */
export const MOBILE_THEME: ThemeDefinition = defineTheme({
    id: "mobile",
    name: "OMP Mobile",
    scheme: "light",
    tokens: {
        color: {
            common: { black: "#000000", white: "#FFFFFF" },
            text: {
                primary: "#333333",
                secondary: "#49454F",
                disabled: "#A8A3AB",
                emphasis: "#1C1A1F",
                inverse: "#FFFFFF",
                danger: "#DE4034",
            },
            background: { default: "#F2F2F2" },
            surface: {
                base: "#FFFFFF",
                hover: "#D4E4F0",
                header: "#BAD0E2",
                modal: "#F7F2FA",
                disabled: "#DCD8E0",
                selected: "#E8F0F8",
            },
            border: {
                default: "#79747E",
                focus: "#2D609B",
                muted: "#C4CDD5",
                danger: "#DE4034",
                disabled: "#BCBABF",
            },
            accent: {
                main: "#2D609B",
                light: "#4680B0",
                dark: "#0D1E4A",
                contrastText: "#FFFFFF",
            },
            danger: {
                main: "#DE4034",
                light: "#FB423B",
                dark: "#B42318",
                contrastText: "#FFFFFF",
            },
            success: {
                main: "#12B76A",
                light: "#D1FADF",
                dark: "#2e7641",
                contrastText: "#FFFFFF",
            },
            warning: {
                main: "#FECC4E",
                light: "#FFF0D0",
                dark: "#ED6C02",
                contrastText: "#1C1A1F",
            },
            neutral: {
                main: "#333333",
                light: "#49454F",
                dark: "#1C1A1F",
                contrastText: "#FFFFFF",
            },
            status: {
                success: "#12B76A",
                successSurface: "#D1FADF",
                warningSurface: "#FFF0D0",
                error: "#DE4034",
                errorSurface: "#FEE4E2",
                info: "#0881BE",
                infoSurface: "#E0F2FE",
            },
            alert: {
                success: "#2e7641",
            },
            skeleton: {
                base: "#c0c0c0",
                highlight: "#e0e0e0",
            },
            overlay: {
                backdrop: "rgba(0, 0, 0, 0.45)",
            },
        },
        space: { unit: 2 },
        radius: {
            xs: "2px",
            sm: "4px",
            md: "8px",
            lg: "12px",
            pill: "9999px",
            circle: "50%",
        },
        borderWidth: {
            hair: "1px",
            thin: "1px",
            medium: "2px",
            thick: "4px",
        },
        shadow: {
            xs: "0 1px 2px rgba(0,0,0,0.05)",
            sm: "0 2px 4px rgba(0,0,0,0.1)",
            md: "0 4px 8px rgba(0,0,0,0.15)",
            lg: "0 8px 16px rgba(0,0,0,0.2)",
            xl: "0 16px 32px rgba(0,0,0,0.25)",
        },
        motion: {
            duration: { fast: "100ms", default: "250ms", long: "500ms" },
            easing: {
                default: "ease-in-out",
                sharp: "cubic-bezier(0.4, 0, 0.2, 1)",
            },
        },
        typography: {
            fontSize: {
                xs: "10px",
                sm: "12px",
                base: "13px",
                md: "14px",
                lg: "16px",
                xl: "18px",
            },
            fontWeight: { regular: 400, medium: 500, semibold: 600, bold: 700 },
            lineHeight: { tight: 1.2, base: 1.5, loose: 1.8 },
        },
        zIndex: {
            auto: 0,
            base: 0,
            bottomSheet: 150,
            header: 1050,
            nav: 1100,
            bottomMenu: 1200,
            modal: 1250,
            overlay: 1300,
            dialog: 1310,
            scannerHint: 1350,
            toast: 1400,
        },
        layout: {
            touchTargetMin: "44px",
            navHeight: "50px",
            pagePadding: "8px",
        },
    },
});
